<template>
  <div>
    <h1 class="title">{{ $t('customer.settings.title') }}</h1>
    <v-container fluid>
      <v-row align="start" justify="center">
        <!-- Create New User Card   -->
        <v-col
          cols="8"
          xl="5"
          lg="5"
          md="8"
          sm="8"
          xs="8"
        >
          <CustomerSettingsProfile/>
        </v-col>
      </v-row>

      <!-- Language Settings   -->
      <v-row align="start" justify="center">
        <v-col
          cols="8"
          xl="5"
          lg="5"
          md="8"
          sm="8"
          xs="8"
        >
          <CustomerSettingsLanguage/>
        </v-col>
      </v-row>

      <v-row align="start" justify="center">
        <!-- Profile Card   -->
        <v-col
          cols="8"
          xl="5"
          lg="5"
          md="8"
          sm="8"
          xs="8"
        >
          <CustomerSettingsCreateNewUser/>
        </v-col>
      </v-row>

    </v-container>
  </div>
</template>

<script>
  export default {
    components: {
      CustomerSettingsLanguage: () => import('@/components/CustomerSettingsLanguage'),
      CustomerSettingsCreateNewUser: () => import('@/components/CustomerSettingsCreateNewUser'),
      CustomerSettingsProfile: () => import('@/components/CustomerSettingsProfile')
    }
  }
</script>

<style lang="scss" scoped>

</style>